import React, { useState, useRef, useEffect, useMemo } from "react"
import { Link } from "react-router-dom"
import { ChevronLeft, ChevronRight } from "lucide-react"
import Inner from "../../components/Inner"
import { routes } from "../../routes"
import { workApi } from "../../api"

const SlideBanner = ({ children }) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [userInteracted, setUserInteracted] = useState(false)

  const [touchStart, setTouchStart] = useState(0)
  const [touchEnd, setTouchEnd] = useState(0)

  const sliderRef = useRef(null)
  const [works, setWorks] = useState(null)
  const totalSlides = useMemo(() => works?.length, [works])

  const nextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % totalSlides)
  }

  const prevSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide - 1 + totalSlides) % totalSlides)
  }

  const handleUserInteraction = (action) => {
    setUserInteracted(true)
    action()
  }

  const onTouchStart = (e) => {
    setTouchStart(e.touches[0].clientX)
  }

  const onTouchEnd = () => {
    if (touchStart - touchEnd > 500) {
      nextSlide()
    }

    if (touchEnd - touchStart > 500) {
      prevSlide()
    }
  }

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.style.transform = `translateX(-${currentSlide * 100}%)`
    }
  }, [currentSlide])

  useEffect(() => {
    if (!userInteracted && totalSlides > 1) {
      const interval = setInterval(nextSlide, 5000)
      return () => clearInterval(interval)
    }
  }, [userInteracted, totalSlides])

  useEffect(() => {
    const getWorks = async () => {
      const response = await workApi.list({ slider: true })
      setWorks(response)
    }
    getWorks()
  }, [])

  return (
    <>
      <div
        className="relative h-screen sm:max-h-[500px] overflow-hidden"
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
      >
        <div ref={sliderRef} className="flex transition-transform duration-500 h-screen sm:max-h-[500px]">
          {works &&
            works?.map(({ id, slug, painting_urls }, index) => (
              <Link to={routes.works.show(slug)} key={index} className="relative min-w-full">
                <img src={painting_urls?.[0][2]} className="w-full h-full object-cover z-0" alt="" />
                <div className="absolute inset-0 bg-black/20 text-white text-3xl font-bold">
                  <div className="flex w-full h-full items-center p-16 opacity-90">
                    <Inner>{children}</Inner>
                  </div>
                </div>
              </Link>
            ))}
        </div>
        <div className="flex absolute top-0 left-0 w-full h-full justify-between items-center text-white pointer-events-none">
          <ChevronLeft
            size={64}
            onClick={() => handleUserInteraction(prevSlide)}
            className="pointer-events-auto cursor-pointer opacity-30 hover:opacity-70 transition"
          />
          <ChevronRight
            size={64}
            onClick={() => handleUserInteraction(nextSlide)}
            className="pointer-events-auto cursor-pointer opacity-30 hover:opacity-70 transition"
          />
        </div>
      </div>
    </>
  )
}

export default SlideBanner
